import React from 'react';
import CommonPageHeader from '../../components/CommonPageHeader/CommonPageHeader';
import NavHeader from '../../components/NavHeader/NavHeader';
import WhatWeDo from './WhatWeDo/WhatWeDo';
import PageHelmet from '../../components/shared/PageHelmet';
import HomeAbout from '../Home/HomeAbout/HomeAbout';
import HomeOurStory from '../Home/HomeOurStory/HomeOurStory';
import MainFooter from '../../components/MainFooter/MainFooter';
import OurApproach from '../Home/OurApproach/OurApproach';
import { Link } from 'react-router-dom';

const OurApproachData = [
   {
      id: 1,
      title: <h3><Link to="/">Discover</Link></h3>,
      img: "assets/img/project/discover_icon_white.svg",
      content: "Delving into the depths of your vision and understanding end-user perceptions"
   },
   {
      id: 2,
      title: <h3><Link to="/">Define</Link></h3>,
      img: "assets/img/project/define_icon_white.svg",
      content: "Blueprinting the scope of work involved and the roadmap to accomplishment"
   },
   {
      id: 3,
      title: <h3><Link to="/">Design</Link></h3>,
      img: "assets/img/project/design_icon_white.svg",
      content: "Creating user journeys, interactions, testing ideas through mockups & wireframes"
   },
   {
      id: 4,
      title: <h3><Link to="/">Develop</Link></h3>,
      img: "assets/img/project/develop_icon_white.svg",
      content: "Breathing life into wireframes & sculpting functionality within interactions through technology"
   },
   {
      id: 5,
      title: <h3><Link to="/">Deliver</Link></h3>,
      img: "assets/img/project/deliver_icon_white.svg",
      content: "Iterating, reiterating, validating and finalizing the polished outcome ready to hit the market"
   }
]
const bgColors = ["#006ce0", "#001133", "#006ce0", "#001133", "#006ce0"];

const OurStory = () => {
   return (
      <>
         <PageHelmet
            pageTitle="Our Story"
            description="Harsoft Solutions is a software development company and web development company with two decades of collective experience delivering mobile app development, AI development services, and SaaS development."
            keywords="Software Development Company, Web Development Company, About Harsoft Solutions"
            path="/ourStory"
         />

         <NavHeader />
         <main>
            <CommonPageHeader title="Our Story" subtitle="Our Story" />
            <HomeAbout />
            <HomeOurStory />
            <WhatWeDo />
            <OurApproach OurApproachData={OurApproachData} bgColors={bgColors} title="Our Approach" />
         </main>
         <MainFooter />
      </>
   );
};

export default OurStory;